import {TitleCasePipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ProjectViewActivity} from 'src/app/core/model/project';
import {User} from 'src/app/core/model/user';
import {ProjectViewActivityActionPipe} from '../pipes/project-view-activity-action.pipe';
import {PipesModule} from 'src/app/shared/pipes/pipes.module';
import {ProjectViewActivityAction} from '../project-view-activity-action';
import * as moment from 'moment';

@Component({
  selector: 'project-view-activity-item',
  standalone: true,
  imports: [TitleCasePipe, ProjectViewActivityActionPipe, PipesModule],
  templateUrl: './project-view-activity-item.component.html',
  styleUrl: './project-view-activity-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectViewActivityItemComponent implements OnChanges {
  @Input() activityItem: ProjectViewActivity;
  @Input() user: User;

  subtext: string;
  ProjectViewActivityAction = ProjectViewActivityAction;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.activityItem && this.activityItem) {
      const action = this.activityItem.action as ProjectViewActivityAction;
      if (action === ProjectViewActivityAction.Custom) {
        this.subtext = this.activityItem.details.alertText;
      } else if (action === ProjectViewActivityAction.ExpiringSoon) {
        this.subtext = `Expires in ${moment.duration(this.activityItem.details.remainingTime).humanize()}`;
      } else {
        this.subtext = this.activityItem.details.taskName;
      }
    }
  }
}
